import axios from './http'

const AUTH_URLS = {
    obtain: 'auth/jwt/obtain/',     // корректно по Swagger
    refresh: 'auth/jwt/refresh/',   // корректно по Swagger
    passwordReset: 'auth/users/reset_password/', // отправка письма на e-mail
    passwordResetConfirm: 'auth/users/reset_password_confirm/', // подтверждение нового пароля
}


export default {
    async obtainToken(payload) {
        // payload: { username, password } либо { email, password }
        const { data } = await axios.post(AUTH_URLS.obtain, payload)
        return data // { access, refresh }
    },
    async refreshToken(refresh) {
        const { data } = await axios.post(AUTH_URLS.refresh, { refresh })
        return data // { access }
    },
    async requestPasswordReset(email) {
        const { data } = await axios.post(AUTH_URLS.passwordReset, { email })
        return data
    },
    async resetPasswordConfirm({ uid, token, new_password, re_new_password }) {
        const { data } = await axios.post(AUTH_URLS.passwordResetConfirm, {
            uid,
            token,
            new_password,
            re_new_password,
        })
        return data
    },
    async getMe() {
        const { data } = await axios.get('employees/me/')
        return data // CurrentUser
    }
}